import { Swiper } from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

const alertContainer = document.querySelector('.block-alert-top');

//Add height to body for other fixed/absolute elements
if (alertContainer) {
	const alertObserver = new ResizeObserver((entries) => {
		entries.forEach(() => {
			const alertContainerTop = alertContainer.offsetTop;
			const alertContainerHeight = alertContainer.offsetHeight;

			document.body.style.setProperty(
				'--alert-height',
				`${(alertContainerHeight + alertContainerTop) / 16}rem`
			);
		});
	});

	alertObserver.observe(alertContainer);

	const swiper = alertContainer.querySelector('.swiper');
	new Swiper(swiper, {
		grabCursor: true,
		slidesPerView: 1,
		loop: true,
		speed: 5000,
		autoplay: {
			delay: 5000,
		},
		modules: [Navigation, Autoplay],
		navigation: {
			prevEl: `.swiper-button-prev`,
			nextEl: `.swiper-button-next`,
		},
	});
}
